/**
 * Staff-only: sync a published package's recorded scope to the supplier's
 * current invite without emailing the supplier (dismiss scope-change reminder).
 */
import { getFunctions, httpsCallable } from 'firebase/functions';
import type { CncSpeciesAssignment, ProposalNodeSet, TimberSupplierStructureRef } from '../types';

export type AcknowledgeRfqPackageScopeDriftInput = {
  packageId: string;
  scopeStructures?: TimberSupplierStructureRef[];
  proposalNodeSets?: ProposalNodeSet[];
  /** Timber only — species per structure to record on the package; null clears. */
  structureSpecies?: Record<string, string[]> | null;
  cncSpeciesAssignments?: CncSpeciesAssignment[];
  cncBoardFeet?: number;
};

export type AcknowledgeRfqPackageScopeDriftResult = {
  ok: boolean;
};

export async function acknowledgeRfqPackageScopeDrift(
  input: AcknowledgeRfqPackageScopeDriftInput,
): Promise<AcknowledgeRfqPackageScopeDriftResult> {
  const functions = getFunctions(undefined, 'us-central1');
  const callable = httpsCallable<
    AcknowledgeRfqPackageScopeDriftInput,
    AcknowledgeRfqPackageScopeDriftResult
  >(functions, 'acknowledgeRfqPackageScopeDrift');
  const result = await callable(input);
  return result.data;
}
